import type { DeviceInventoryPatternGeneration } from '../-components/DeviceInventoryOperation/query/selector';
import type { ItPackagePatterns } from './type';

/**
 * 棚卸しのパターンを v2 が先頭になるよう並べ替える。
 *
 * `OperationPackagePattern` には順序を表す列が無く、`OperationPackagePatternTemporal.validFrom` も
 * v1 のリネームで新しい行が立つため当てにならない。パターン一覧 API
 * （`ListOperationPatternQueryService`）は全パッケージ共通なので、棚卸し固有の並び順は
 * ここで解く。
 *
 * 並べ替えはタブの左端だけでなく**既定 patternId** にも効く
 * （`$packageId.tsx` が `packagePatterns[0]` を選ぶ）。
 *
 * 世代が引けないパターンは v1 と同じ扱いで後ろへ送る。v2 と証明できないものを
 * 先頭に置くと、既定選択が旧パターンになりうるため。
 */
export function sortDeviceInventoryPatterns(patterns: ItPackagePatterns, generations: ReadonlyMap<string, DeviceInventoryPatternGeneration> | undefined): ItPackagePatterns {
  if (generations === undefined) {
    return patterns;
  }

  // Array.prototype.sort は安定ソートなので、同順位は元の順序が保たれる
  return [...patterns].sort((a, b) => {
    const rank = (id: string) => generations.get(id) === 'v2' ? 0 : 1;
    return rank(a.operationPackagePatternId) - rank(b.operationPackagePatternId);
  });
}